module.exports = __webpack_public_path__ + "img/comments-question.bde0a2c1.svg";